<template>
    <div class="d-flex flex-row align-items-center justify-content-end">
        <button
            :disabled="minCondition"
            @click.prevent="emitter('onDecrease')"
            class="btn btn-outline-secondary py-0 px-2 btn-sm"
        >-</button>
        <div class="px-2">
            {{ quantity }}
        </div>
        <button
            :disabled="maxCondition"
            @click.prevent="emitter('onIncrease')"
            class="btn btn-outline-secondary py-0 px-2 btn-sm"
        >+</button>
    </div>
</template>

<script setup lang="ts">
const emitter = defineEmits<{
    (e: 'onIncrease'),
    (e: 'onDecrease')
}>()
const { quantity } = defineProps<{
    quantity: number,
    maxCondition: boolean
    minCondition: boolean
}>()

</script>

<style scoped>

</style>
